<template>
<div class="chapter">
<div class="inner_page">
<p class="cimage"><img alt="image" src="images/ch.jpg"/></p>
<h2 class="fm-title"><span class="bold">Contents</span></h2>
<p class="tocf"><a href="#/xhtml/fm03">Acknowledgments</a></p>
<p class="tocf"><a href="#/xhtml/fm04">Foreword</a></p>
<p class="tocf"><a href="#/xhtml/fm05">Instructions for This Book</a></p>
<p class="tocf"><a href="#/xhtml/fm06">Introduction</a></p>
<p class="toct"><a href="#/xhtml/chap01"><span class="tno">CHAPTER 1</span> Money Mindset</a></p>
<p class="toc"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">CHAPTER 2</span> What Is Money Anyway?</span></p>
<p class="toc"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">CHAPTER 3</span> How Much Money Do You Want?</span></p>
<p class="toc"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">CHAPTER 4</span> Money: The Big, Fat Lie</span></p>
<p class="toc"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">CHAPTER 5</span> Can Money Buy Happiness?</span></p>
<p class="toc"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">CHAPTER 6</span> Coaches and Mentors</span></p>
<p class="toc"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">CHAPTER 7</span> The Truth About Credit Scores</span></p>
<p class="toc"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">CHAPTER 8</span> Rebuilding Your Credit Using Credit Cards</span></p>
<p class="toc"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">CHAPTER 9</span> LLCs: The Credit Multiplier</span></p>
<p class="toc"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">CHAPTER 10</span> The Right Way to Buy a Car</span></p>
<p class="toc"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="tno">CHAPTER 11</span> How to Buy a House with Credit Cards</span></p>
<p class="toc"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="tno">CHAPTER 12</span> Investing With Other People’s Money (OPM)</span></p>
<p class="toc"><span href="#/xhtml/chap13" title="Link target outside of Sample"><span class="tno">CHAPTER 13</span> Be Your Own Bank</span></p>
<p class="toc"><span href="#/xhtml/chap14" title="Link target outside of Sample"><span class="tno">CHAPTER 14</span> Lend Out Your Equity</span></p>
<p class="toc"><span href="#/xhtml/chap15" title="Link target outside of Sample"><span class="tno">CHAPTER 15</span> How to Choose Stocks</span></p>
<p class="toc"><span href="#/xhtml/chap16" title="Link target outside of Sample"><span class="tno">CHAPTER 16</span> Stocks: The Big Picture</span></p>
<p class="toc"><span href="#/xhtml/chap17" title="Link target outside of Sample"><span class="tno">CHAPTER 17</span> Steak and Tuna</span></p>
<p class="toc"><span href="#/xhtml/chap18" title="Link target outside of Sample"><span class="tno">CHAPTER 18</span> Don’t Pay Taxes!</span></p>
<p class="toc"><span href="#/xhtml/chap19" title="Link target outside of Sample"><span class="tno">CHAPTER 19</span> How to Buy Houses with Your IRA</span></p>
<p class="toc"><span href="#/xhtml/chap20" title="Link target outside of Sample"><span class="tno">CHAPTER 20</span> Tax Secrets of the Super-Rich</span></p>
<p class="toc"><span href="#/xhtml/chap21" title="Link target outside of Sample"><span class="tno">CHAPTER 21</span> Understanding College Loans</span></p>
<p class="toc"><span href="#/xhtml/chap22" title="Link target outside of Sample"><span class="tno">CHAPTER 22</span> How to Thrive in a Bad Economy</span></p>
<p class="toc"><span href="#/xhtml/bm01" title="Link target outside of Sample"><span class="tno">Conclusion</span> Be a Legend</span></p>
<p class="tocft"><span href="#/xhtml/bm02" title="Link target outside of Sample">About the Author</span></p>
<p class="tocf"><span href="#/xhtml/bm03" title="Link target outside of Sample">Endnotes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?860102e2